import * as universalNode from './node';

export * from './node';

export default universalNode;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
